import { trace } from 'rytm-helpers'

let reqTimeout, xhr

export const initAjaxedSearch = () => {
  // Document change & keydown
  document.addEventListener("change", onDocChange, false)
  document.addEventListener("keydown", onDocChange, false)
}

export const abordXhrRequests = () => {
  if (xhr) {
    xhr.abort()
  }
}

// ##########################
// ### Doc event handlers ###
// Doc click
const onDocChange = (e) => {
  if (e.target.dataset.resultsSelector && e.target.dataset.searchUrl) {
    clearTimeout(reqTimeout)
    // cancel xhr request
    abordXhrRequests()
    reqTimeout = setTimeout(() => {
      handleRequest(e.target)
    }, 400)
  }
}

const handleRequest = (trigger) => {
  let url = trigger.dataset.searchUrl
  const selector = trigger.dataset.resultsSelector
  if (!url || !selector) {
    console.warn("unknown url or selector")
    return false;
  }
  const wrapper = document.querySelector(selector)
  if (!wrapper) {
    console.warn("wrapper not found", selector)
    return false;
  }
  const value = trigger.value
  if (value) {
    // add query to URL
    url += "?s=" + encodeURIComponent(value)
    // ajax request
    xhr = new XMLHttpRequest()
    // add event listeners
    // ## Load Success
    xhr.addEventListener('loadend', (e) => {
      wrapper.innerHTML = e.target.responseText
      onXhrLoadEnded()
    });
    // load start
    xhr.addEventListener('loadstart', () => {
      document.documentElement.classList.add("data-loading")
    });
    // xhr.addEventListener('load', onXhrLoad);
    // xhr.addEventListener('progress', onXhrProgress);
    xhr.addEventListener('error', onXhrLoadEnded);
    xhr.addEventListener('abort', onXhrLoadEnded);
    xhr.open('GET', url)
    xhr.send()
  } else {
    wrapper.innerHTML = ""
  }
}

const onXhrLoadEnded = (e) => {
  document.documentElement.classList.remove("data-loading")
}
